import { useEffect, useState } from 'react';
import { DESKTOP_LAYOUT_MEDIA } from './breakpoints';

function readDesktopLayout(): boolean {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
    return true;
  }
  return window.matchMedia(DESKTOP_LAYOUT_MEDIA).matches;
}

/**
 * True at Tailwind `lg+`. Reads matchMedia synchronously on the client so
 * mobile navigation does not flash through the desktop shell first.
 * jsdom (no matchMedia) stays desktop so existing panel tests keep working.
 */
export function useDesktopLayout(): boolean {
  const [isDesktop, setIsDesktop] = useState(readDesktopLayout);

  useEffect(() => {
    if (typeof window.matchMedia !== 'function') return;

    const media = window.matchMedia(DESKTOP_LAYOUT_MEDIA);
    const sync = () => setIsDesktop(media.matches);
    sync();
    media.addEventListener('change', sync);
    return () => media.removeEventListener('change', sync);
  }, []);

  return isDesktop;
}
